import OurStory from "./OurStory";

export default OurStory;
